export default {
  populateLinks: (state) => {
    return state.links;
  },
}
